import { createContext, Dispatch, SetStateAction } from 'react';
import { VtexCoupom } from '../models/vtex-coupom';

export type CoupomContextValue = {
  vtexCoupom: VtexCoupom;
  hasVtexCoupom: boolean;
  activeCoupom: boolean;
  countdown: boolean;
  rules: string[];
  description: string;
  queryVtex: string;
};

type CreateCoupomContext = [
  CoupomContextValue,
  Dispatch<SetStateAction<CoupomContextValue>>,
];

export const CoupomFormContextDefaultValue = {
  vtexCoupom: {} as VtexCoupom,
  hasVtexCoupom: false,
  activeCoupom: false,
  countdown: false,
  rules: [] as any,
  description: '',
  queryVtex: '',
};

export const CoupomFormContext = createContext<CreateCoupomContext>([
  CoupomFormContextDefaultValue,
  () => undefined,
]);
